"use client";

import {memo, useCallback, useMemo} from "react";

import {derive} from "derive-valtio";
import {useSnapshot} from "valtio";

import {RentalCard} from "@/entities/rental";

import {useMatchMedia} from "@/shared/hooks";
import {useTranslation} from "@/shared/i18n";
import {capitalizeFirstLetter} from "@/shared/lib";
import {routes} from "@/shared/utils";

import {SearchPageInstance} from "@/app/(search)/search/search-page.model";

interface Props {
    model: SearchPageInstance;
}

export const ListProperties = memo(function ListProperties({model}: Props) {
    const isMobile = useMatchMedia({maxWidth: 1024});
    const {t} = useTranslation("search");

    const derived = useMemo(() => {
        return derive({
            propertiesWithQuery: (get) => {
                return get(model).placesWithQuery;
            },
        });
    }, [model]);

    const snap = useSnapshot(derived);

    const handleCardHover = useCallback(
        (id: string) => {
            model.map.setHoveredUnit(id);
        },
        [model.map],
    );

    const handleCardLeave = useCallback(() => {
        model.map.clearHoveredUnit();
    }, [model.map]);

    return (
        <div className="search-content__grid">
            {snap.propertiesWithQuery.map((place) => (
                <RentalCard
                    key={place.id}
                    {...place}
                    location={t("housingTypeIn", {type: capitalizeFirstLetter(place.housingType), location: place.location})}
                    link={routes.rental.detail.url(place.slug ?? "")}
                    onCardHover={isMobile ? undefined : handleCardHover}
                    onCardLeave={isMobile ? undefined : handleCardLeave}
                />
            ))}
        </div>
    );
});
